import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@examdojo/core/environment';
import { UserRole } from '@examdojo/models/user';

interface PromoteUsersRequest {
  role: UserRole;
  emails: string[];
}

interface PromoteUsersSuccessResponse {
  result: {
    status: 'success';
  };
}

interface PromoteUsersErrorResponse {
  result: {
    status: 'error';
    error_code: 'invalid_email' | 'already_on_platform';
    emails: string[];
  };
}

type PromoteUsersResponse = PromoteUsersSuccessResponse | PromoteUsersErrorResponse;

@Injectable({ providedIn: 'root' })
export class UserPromoteHttpService {
  constructor(private readonly http: HttpClient) {}

  private readonly baseUrl = `${environment.examdojo.examdojoApiUrl}/auth/users/promote`;

  promoteUsers(role: UserRole, emails: string[]) {
    return this.http.post<PromoteUsersResponse>(this.baseUrl, {
      role,
      emails,
    } satisfies PromoteUsersRequest);
  }
}
